<script setup>
import { ref } from 'vue'
const props = defineProps(['project', 'type'])

const types = ref([
	{
		circle: 'https://cdn.papercrowns.com/website/images/elements/circle-1.png',
	},
	{
		circle: 'https://cdn.papercrowns.com/website/images/elements/circle-2.png',
	},
	{
		circle: 'https://cdn.papercrowns.com/website/images/elements/circle-1.png',
	},
	{
		circle: 'https://cdn.papercrowns.com/website/images/elements/circle-2.png',
	},
	{
		circle: 'https://cdn.papercrowns.com/website/images/elements/circle-1.png',
	},
])
</script>

<template>
	<div class="relative mx-3 h-full text-white">
		<img class="absolute hidden w-[110%] lg:-left-2 lg:block" :src="types[type - 1]?.circle" alt="" />
		<img class="aspect-video object-cover object-center" :src="project.poster" alt="" />
		<!-- <video class="h-full" src="https://cdn.papercrowns.com/website/content/projects/featured-video/ghost.mp4" autoplay loop muted></video> -->
	</div>
</template>
